// import { createStore, applyMiddleware } from "redux";
// import {thunk} from "redux-thunk";
// import { composeWithDevTools } from "redux-devtools-extension";
// import rootReducer from "../root/rootReducer";

// const store = createStore(
//   rootReducer,
//   composeWithDevTools(applyMiddleware(thunk))
// );

// export default store;

import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import {thunk} from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "../root/rootReducer";

// Persist config
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // ✅ only persist auth reducer
};

// Wrap root reducer with persist
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store
const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

// Create persistor
export const persistor = persistStore(store);

export default store;
